import { SignUpSteps } from "../../shared/types/common.enums";

export const SignupFlowStepsRoutes = new Map<SignUpSteps, string>([
    [SignUpSteps.selectYourFarmbox, 'farmbox'],
    [SignUpSteps.deliveryInformation, 'delivery'],
    [SignUpSteps.personalInformation, 'personal'],
    [SignUpSteps.paymentInformation, 'payment']
]);
